export const routeClick = 'route_click';
export const resumeEditClick = 'resume_edit_click';
export const bioDataEditClick = 'bio_data_edit_click';
export const resignationEditClick = 'resignation_edit_click';
export const CoverEditClick = 'cover_edit_click';
export const resumeDuplicateClick = 'resume_duplicate_click';
export const coverDuplicateClick = 'cover_duplicate_click';
export const resignationLetterDuplicateClick =
  'resignation_letter_duplicate_click';
export const bioDataDuplicateClick = 'bio_data_duplicate_click';
export const resumeDownloadPdfClick = 'resume_download_click';
export const bioDataDownloadPdfClick = 'bio_data_download_click';
export const coverDownloadPdfClick = 'cover_download_click';
export const resumeDeleteClick = 'resume_delete_click';
export const coverDeleteClick = 'cover_delete_click';
export const backToEditorClick = 'back_to_editor_click';

export const myAccountMenuClick = 'my_account_menu_click';
export const myMenuResumeClick = 'my_menu_resume_click';
export const mySignoutMenuClick = 'my_menu_signout_click';
export const deleteAccountClick = 'delete_account_click';
export const useAiWriter = 'use_ai_writer';
export const generateWithAi = 'generate_with_ai';
export const uploadLinkedinFile = 'upload_file_on_linkedin';
export const earnFreeCredits = 'earn_free_credits';
export const myOrdersMenuClick = 'my_orders_menu_click';
export const myScanHistoryClick = 'my_scan_history_click';
export const myFreeCreditsMenuClick = 'my_free_credits_request_click';
export const paymentsClick = 'payment_click';

export const useJDWriter = 'use_jd_writer';
export const generateCoverLetterFromMenu = 'generate_cover_letter_from_menu';
export const generateWithJD = 'generate_with_jd';
export const openShareDialog = 'open_share_dialog';
export const shareLinkCopied = 'share_link_copied';       // params: { context } — resume | cover | bio_data
export const sharedResumeViewed = 'shared_resume_viewed'; // params: { context, resume_id }
export const openDownloadQRCodeDialog = 'open_download_qr_code_dialog';
export const resumePublished = 'resume_published';

export const generateContentAiMenu = 'generate_content_ai_menu';
export const improveWritingAiMenu = 'improving_writing_ai_menu';
export const makeShorterAiMenu = 'make_shorter_ai_menu';
export const makeLongerAiMenu = 'make_longer_ai_menu';
export const correctGrammerAiMenu = 'correct_grammer_ai_menu';
export const quantifyTextAiMenu = 'quantify_text_ai_menu';
export const acceptImproveWriting = 'accept_improve_writing';
export const editPublicTemplate = 'edit_public_template';

export const tailorResumeScrollStepper =
  'scan_btn_tailor_resume_scroll_stepper';
export const atsResumeScoreScrollStepper =
  'scan_btn_tailor_resume_scroll_stepper';
export const downloadChromeExtensionBtn = 'download_chrome_extension_btn';
export const getScoreButton = 'get_score_button';
export const getInterviewQuestionsButton = 'get_interview_questions_button';
export const closePaymentHookBuilder = 'close_payment_hook_in_builder';
export const getResumeScoreInBuilder = 'get_resume_score_in_builder';
export const createNewScanInBuilder = 'create_new_scan_in_builder';
export const findJobDescriptionOnGoogle = 'find_job_description_on_google';

// JD input tab selection
export const jdTabFetchLink = 'jd_tab_fetch_link';
export const jdTabGenerateFromTitle = 'jd_tab_generate_from_title';
export const jdTabPasteText = 'jd_tab_paste_text';

// JD URL fetch outcomes
export const jdFetchSuccess = 'jd_fetch_success';
export const jdFetchError = 'jd_fetch_error';     // params: { reason }

// JD AI generation from title
export const jdGeneratedFromTitle = 'jd_generated_from_title';

// Tailor dialog funnel — step abandonment
export const tailorDialogStepView = 'tailor_dialog_step_view';   // params: { step, stepName }
export const tailorDialogAbandoned = 'tailor_dialog_abandoned';  // params: { atStep, stepName }

export const createResumeDialogHook = 'create_resume_dialog_hook';
export const downloadInvoice = 'download_invoice_click';

// Zero state (empty listing page) — action buttons
export const zeroStateResumeCreateAi = 'zero_state_resume_create_ai';
export const zeroStateResumeImport = 'zero_state_resume_import';
export const zeroStateResumeFromRole = 'zero_state_resume_from_role';
export const zeroStateResumeBlank = 'zero_state_resume_blank';
export const zeroStateCoverCreateAi = 'zero_state_cover_create_ai';
export const zeroStateCoverBlank = 'zero_state_cover_blank';
export const zeroStateBioUpload = 'zero_state_bio_upload';
export const zeroStateBioBlank = 'zero_state_bio_blank';

// Download dialog — all prefixed dd_ so they're filterable as a group in GA4
export const downloadDialogShown = 'dd_shown';
export const downloadCompleted = 'dd_complete';
export const downloadFailed = 'dd_failed';
export const atsCTAClicked = 'dd_ats_cta';
export const downloadDialogClosed = 'dd_closed';
export const trustpilotClicked = 'dd_trustpilot';
export const ddShareLinkCopied = 'dd_share_link_copied';
